function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/no-multi-comp */
import React from "react";
import { DisplayComponent } from "~/components/newsletter/newsletter-widget/enums";
import { SignUpNewsletter } from "./homepage-theme-sign-up-newsletter";
import { SignUpSuccessMessage } from "./homepage-theme-sign-up-success-message";
export const useHomepageRender = onSuccess => ({
  [DisplayComponent.SignUpNewsletter]: props => /*#__PURE__*/React.createElement(SignUpNewsletter, _extends({
    isShowOverlaySignUp: true,
    onSuccess: onSuccess
  }, props)),
  [DisplayComponent.SignUpSuccessMessage]: _props => /*#__PURE__*/React.createElement(SignUpSuccessMessage, null)
});